export default __webpack_public_path__ + "static/media/card-no-present.bf14202f.svg";